import { z } from 'zod';


export const coordinatesSchema = z.object({
  latitude: z.coerce.number({ invalid_type_error: 'invalid' }).finite(),
  longitude: z.coerce.number({ invalid_type_error: 'invalid' }).finite(),
});

export type CoordinatesFormData = z.infer<typeof coordinatesSchema>;
